import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqImagePanelComponent } from './faq-image-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { FaqImagePanelItemModule } from './components/faq-image-panel-item/faq-image-panel-item.module';

@NgModule({
  declarations: [FaqImagePanelComponent],
  exports: [FaqImagePanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FaqImagePanelItemModule,
  ],
})
export class FaqImagePanelModule { }
